import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private httpclient: HttpClient) { }

  getOnlinePaymentMagPiePayNow(transaction) {
    return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayMagPie/OnlinePaymentPayNowJoinOnline', transaction)
  }

  // makePaymentAyden(model) {
  //   return this.httpclient.post(environment.appUrl + '/api/PaymentGatewayAdyen/MakePaymentAyden', model)
  // }
}
